export const getAge = (dateString) => {
  var now = new Date();
  var yearNow = now.getYear();
  var monthNow = now.getMonth();
  var dateNow = now.getDate();

  var dob = new Date(
    dateString.substring(6, 10),
    dateString.substring(0, 2) - 1,
    dateString.substring(3, 5)
  );

  var yearDob = dob.getYear();
  var monthDob = dob.getMonth();
  var dateDob = dob.getDate();

  let yearAge = yearNow - yearDob;

  if (monthNow >= monthDob) var monthAge = monthNow - monthDob;
  else {
    yearAge--;
    monthAge = 12 + monthNow - monthDob;
  }

  let dateAge = "";
  if (dateNow >= dateDob) {
    dateAge = dateNow - dateDob;
  } else {
    monthAge--;
    dateAge = 31 + dateNow - dateDob;

    if (monthAge < 0) {
      monthAge = 11;
      yearAge--;
    }
  }

  let years =
    yearAge === 0
      ? "< 1"
      : yearAge > 0 && yearAge < 10
      ? "0" + yearAge
      : yearAge;
  return years;
};

export const USAPhoneNumberFormate = (phone) => {
  const cleaned = `${phone}`.replace(/\D/g, "");
  const match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    const intlCode = match[1] ? "+1 " : "";
    const number = [
      intlCode,
      "(",
      match[2],
      ") ",
      match[3],
      "-",
      match[4],
    ].join("");
    return number;
  }
  return phone;
};

// const makeCall = (phone) => {
//   let phoneNumber = "";
//   if (
//     phone === "" ||
//     phone === null ||
//     phone === " " ||
//     phone === undefined
//   ) {
//     Alert.alert(I18n.t("warning"), I18n.t("EmptyPhone"));
//     return false;
//   } else {
//     if (Platform.OS === "android") {
//       phoneNumber = `tel:${phone}`;
//     } else {
//       phoneNumber = `telprompt:${phone}`;
//     }
//     Linking.openURL(phoneNumber);
//   }
// };

// const sendMessage = (phone, firstName) => {
//   const bodyMsg = "Dear " + firstName + " , \n";
//   if (
//     phone === "" ||
//     phone === null ||
//     phone === " " ||
//     phone === undefined
//   ) {
//     Alert.alert(I18n.t("warning"), I18n.t("EmptyPhone"));
//     return false;
//   } else {
//     if (Platform.OS === "android") {
//       Linking.openURL("sms:" + phone + "?body=" + bodyMsg);
//     } else {
//       Linking.openURL("sms:" + phone + "&body=" + bodyMsg);
//     }
//   }
// };

// const sendEmail = (email, firstName) => {
//   const subject = "Hello " + firstName + " !";
//   const bodyMsg = "Dear " + firstName + " , \n";
//   if (
//     email === "" ||
//     email === null ||
//     email === " " ||
//     email === undefined
//   ) {
//     Alert.alert(I18n.t("warning"), I18n.t("EmptyEmailId"));
//     return false;
//   } else {
//     let link = `mailto:${email}?subject=${subject}&body=${bodyMsg}`;
//     Linking.canOpenURL(link)
//       .then((supported) => {
//         if (!supported) {
//           console.log("Cant handle url");
//         } else {
//           Linking.openURL(link);
//         }
//       })
//       .catch((err) => console.error("An error occurred", err));
//   }
// };
